'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Node = require('./node');

var DefaultGraph = function (_Node) {
  _inherits(DefaultGraph, _Node);

  function DefaultGraph() {
    _classCallCheck(this, DefaultGraph);

    var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(DefaultGraph).call(this));

    _this.termType = 'DefaultGraph';
    _this.value = '';
    return _this;
  }

  _createClass(DefaultGraph, [{
    key: 'toCanonical',
    value: function toCanonical() {
      return this.value;
    }
  }]);

  return DefaultGraph;
}(Node);

module.exports = DefaultGraph;


//////////////////
// WEBPACK FOOTER
// ./~/rdflib/lib/default-graph.js
// module id = 76
// module chunks = 0